import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const IconButton = styled.div<{
  small?: boolean;
  disabled?: boolean;
  size?: number;
}>`
  width: ${p => p.size ?? 24}px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: ${p => p.size ?? 18}px;
  }
  padding: 3px;
  border-radius: 3px;

  color: ${globals.MOON_500};
  ${p =>
    p.disabled &&
    css`
      color: ${globals.MOON_300};
      cursor: not-allowed;
      pointer-events: none;
    `}
  &:hover {
    ${p =>
      !p.disabled &&
      css`
        color: ${globals.MOON_800};
        background-color: ${globals.hexToRGB(globals.OBLIVION, 0.05)};
      `}
  }

  &:not(:last-child) {
    margin-right: 4px;
  }
`;
